import React from "react";
import Table, { TableRow, TableCell } from "@amzn/meridian/table";

export const ScrubInvocationDetailsTable = ({translatedHeaders, headers, contents}) => {

    return (
        <div style={{overflowX: "auto", maxWidth: "100%" }} >
            <Table headerRows={1} showStripes={true}
                   showDividers={true}
                   spacing="small">
                <TableRow highlightOnHover={true}>
                    {translatedHeaders.map(item => (
                        <TableCell key={item} >
                            {item}
                        </TableCell>
                    ))}
                </TableRow>

                {
                    contents.map(item => (
                        <TableRow highlightOnHover={true}>
                            {
                                headers.map((value) => (
                                    <TableCell key={value} >{item[value]}</TableCell>
                                ))
                            }
                        </TableRow>
                    ))
                }
            </Table>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/scrub/ScrubInvocationDetailsTable.js